import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, DeferLoadingStrategy, provideConfig } from '@spartacus/core';
import { PageLayoutComponent } from '@spartacus/storefront';
import { PaymentConfirmationLoaderComponent } from './payment-confirmation-loader/payment-confirmation-loader.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'payment-confirmation/:cartId',
        component: PageLayoutComponent,
        data: { pageLabel: '/payment-confirmation' },
      },
    ]),
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        PaymentLoader: {
          component: PaymentConfirmationLoaderComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    }),
  ],
})
export class ShimanoPaymentModule {}
